module.exports = __webpack_public_path__ + "static/coupon1-e63747b5f22d8b391301b3626d966d09.png";